import { useTrans } from "@/utils/useTrans";
import { useAboutVideos } from "../_hooks/useAboutVideos";
import { VideoCard } from "./VideoCard";

export default function CommunityReviewsSection() {
  const { t } = useTrans(["about", "gnb"]);
  const videos = useAboutVideos();

  return (
    <div className="flex flex-col items-center justify-center gap-8 self-stretch">
      <div className="justify-start self-stretch text-center text-2xl laptop:text-4xl">
        {t(`bHaptics Community Reviews`)}
      </div>
      <div className="flex flex-col items-start justify-start gap-8 self-stretch">
        <div className="grid gap-4 gap-y-8 self-stretch smd:grid-cols-2 laptop:grid-cols-3">
          {videos.data?.map((video) => (
            <VideoCard key={video.id} video={video} />
          ))}
        </div>
      </div>
    </div>
  );
}
